import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Loader from '../Loader';
import { get } from "../../utility/Adapter";
import DataTable from "react-data-table-component";

const Dashboard = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadCandidates();
    }, []);

    const loadCandidates = () => {
        setLoading(true);
        get("staff/candidates")
            .then((response) => {
                console.log("Staff candidates response:", response.data);
                setCandidates(response.data); // Correctly set the candidates from the response
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1,
        },
        {
            name: "Name",
            selector: (row) => (
                <a href={"/staff/candidate/" + row._id} target="_blank">
                    <span className="text-capitalize">
                        {row.candidate_first_name + " " + row.candidate_last_name}
                    </span>
                </a>
            ),
        },
        {
            name: "Phone",
            selector: (row) => row.candidate_phone,
        },
        {
            name: "Email",
            selector: (row) => row.candidate_email,
        },
        {
            name: "Nursing License",
            selector: (row) => (row.candidate_licence === "Y" ? "Yes" : "No"),
        },
        {
            name: "Documents",
            selector: (row) => row.documents_count,
        },
        {
            name: "Created",
            selector: (row) => row.created,
        },
    ];

    return (
        <>
            <Header />
            <Loader loading={loading} />
            <main>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="page-title-container">
                                <div className="row g-0">
                                    <div className="col-auto mb-2 mb-md-0 me-auto">
                                        <div className="w-auto sw-md-30">
                                            <h1 className="mb-0 pb-0 display-4" id="title">
                                                Assigned Candidates
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <DataTable
                                        columns={columns}
                                        data={candidates}
                                        pagination
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default Dashboard;